import React from 'react'
import { Link } from 'react-static'
import styled from 'styled-components'
import { position } from 'polished'

import { scrollToTop } from '../../../animations'
import Reveal from '../../common/Reveal'
import Button from '../../common/Button'

import outboard from '../../../images/outboard.png'
import arrowUp from '../../../images/icons/arrow-up.png'

const Wrapper = styled.section`
  position: relative;
  text-align: center;
  background-color: ${props => props.theme.main.bg};
  overflow: hidden;
  transform: translate3d(0, 0, 0);

  .ekadek {
    padding: 6em 25px;
    position: relative;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-flow: column nowrap;
    min-height: 27em;
    position: relative;

    @media screen and (min-width: 501px) and (max-width: 800px) {
      padding: 7em 50px;
    }

    @media screen and (min-width: 801px) and (orientation: landscape) {
      height: 80vh;
      flex-flow: row nowrap;
      padding: 0 50px;
    }

    @media screen and (min-width: 801px) and (orientation: portrait) {
      padding: 12em 50px;
      flex-flow: row nowrap;
      justify-content: center;
    }

    .text {
      width: 100%;
      max-width: 36em;

      p {
        font-size: 1.1em;
      }

      .home-bottom-inner {
        max-width: ${props => props.theme.main.maxWidth - 10}em;
        margin: 0 auto;
      }

      .caution {
        color: ${props => props.theme.secondary.bg3};
        margin: 3em auto 0;
        position: relative;
        font-style: italic;
      }

      a {
        display: inline-block;
      }

      button {
        margin-top: 1.5em;
        font-size: 1.1em;
        font-weight: 400;
        transition: color 0.3s ease, background-color 0.3s ease, border-color 0.3s ease;

        &:hover {
          color: #fff;
          background-color: ${props => props.theme.secondary.bg2};
          border-color: ${props => props.theme.secondary.bg2};
          opacity: 1;
        }
      }

      @media screen and (min-width: 801px) {
        padding: 0 2em;
        max-width: none;
      }

      @media screen and (min-width: 801px) and (orientation: landscape) {
        width: 60%;
      }
    }
  }

  .bottom-img-wrapper {
    position: absolute;
    top: 50%;
    left: 9.5%;
    transform: translateY(-36%);
    width: 31%;
    margin: 0;
    display: none;

    img {
      width: 100%;
    }
  }

  .home-contact {
    background-color: ${props => props.theme.secondary.bg3};
    width: 100%;
    position: relative;
    padding: 4em 50px;

    .inner {
      padding-bottom: 40px;

      a {
        display: inline-block;
      }
    }

    .arrow {
      display: none;
    }

    p {
      margin-bottom: 1.5em;
      color: ${props => props.theme.main.hover};
    }

    button {
      transition: all 0.3s ease;

      &:hover {
        background-color: #fff;
        color: ${props => props.theme.secondary.bg3};
        opacity: 1;
      }
    }

    @media screen and (min-width: 801px) {
      padding: 4em 50px;

      p {
        padding-right: 2em;
        margin-bottom: 0;
        display: inline-block;
      }

      .arrow {
        padding: 0.5em;
        width: 2.2em;
        cursor: pointer;
        z-index: 10;
        ${position('absolute', 'calc(39% - 28px)', null, null, '25px')};
        display: block;
      }
    }

    @media screen and (min-width: 801px) and (orientation: landscape) {
      height: 20vh;
      min-height: 8em;
      padding: 0 50px;
      display: flex;
      align-items: center;
      justify-content: center;

      .inner {
        padding-bottom: 0;
      }

      .arrow {
        ${position('absolute', 'calc(50% - 28px)', null, null, '25px')};
      }
    }

    @media screen and (min-width: 1001px) {
      p {
        font-size: 1.3em;
      }
    }
  }

  .copyright {
    p {
      line-height: 40px;
      font-size: 0.9em;
      color: ${props => props.theme.secondary.bg3};

      small {
        font-size: 0.9em;
      }

      span {
        padding: 0 1em;
        color: #ccc;
      }
    }

    a {
      font-weight: bold;
      color: ${props => props.theme.secondary.bg3};

      &:hover {
        text-decoration: underline;
      }
    }
  }

  .copyright-mobile {
    background-color: #fff;
    height: 40px;
    text-align: center;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
  }

  .copyright-desktop {
    position: absolute;
    top: 2em;
    left: -8.5em;
    width: 25em;
    padding: 1em;
    display: none;

    .copyright-desktop-bg {
      background-color: rgba(255, 255, 255, 0.1);
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 3;
    }

    .copyright-desktop-inner {
      position: relative;
      z-index: 4;
    }

    p {
      padding: 0 0.5em;
      display: block;
      margin: 0;
      line-height: 1.3;
      font-size: 1em;
      color: #f5f5f5;
    }

    a {
      font-weight: bold;
      color: #f5f5f5;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  @media (min-width: 801px) and (orientation: landscape) {
    .copyright-desktop {
      display: block;
    }

    .copyright-mobile {
      display: none;
    }

    .bottom-img-wrapper {
      display: block;
    }
  }
`

const CopyrightMobile = () => (
  <Reveal offset={1.05} className="copyright copyright-mobile" key="copy-mobile">
    <p>
      &copy;{' '}
      <small>
        Bagnall Hill {new Date().getFullYear()} <span>|</span> Site by{' '}
        <a href="mailto:meandillar@gmail.com">meandillar</a>
      </small>
    </p>
  </Reveal>
)

const CopyrightDesktop = () => (
  <Reveal
    initialStyles={{ autoAlpha: 0, x: -60, rotation: -45 }}
    finalStyles={{ autoAlpha: 1, x: 0, rotation: -45 }}
    offset={0.1}
    className="copyright copyright-desktop"
    key="copy-desktop"
  >
    <div className="copyright-desktop-bg" />
    <div className="copyright-desktop-inner">
      <p>
        &copy; <small>Bagnall Hill {new Date().getFullYear()}</small>
      </p>
      <p>
        <small>
          Site by <a href="mailto:meandillar@gmail.com">meandillar</a>
        </small>
      </p>
    </div>
  </Reveal>
)

const Bottom = ({ mobile }) => (
  <Wrapper className="home-contact">
    <div className="ekadek">
      <Reveal offset={0.7} className="bottom-img-wrapper">
        <img className="bottom-img" src={outboard} alt="outboard gear" />
      </Reveal>
      <div className="text" key="bottom-text">
        <Reveal className="home-bottom-inner">
          <h3>SIGNAL PROCESSING</h3>
          <p>
            At the heart of Bagnall Hill lies a unique assortment of outboard gear lovingly crafted
            by Ekadek Electronics. This stuff really gets the pulse racing. For more info hit the
            button below.
          </p>
          <p>
            <span className="caution">
              CAUTION: Adding Ekadek to your signal path can cause out-of-body experiences.
            </span>
          </p>
          <a href="http://www.ekadek.com" target="_blank" rel="noopener noreferrer">
            <Button>CHECK OUT EKADEK</Button>
          </a>
        </Reveal>
      </div>
    </div>
    <Reveal className="home-contact">
      <div className="inner">
        <p>Interested in recording at Bagnall Hill?</p>
        <Link to="/contact">
          <Button>CONTACT US</Button>
        </Link>
      </div>
      <img onClick={() => scrollToTop(1.5)} className="arrow" src={arrowUp} alt="Back To Top" />
    </Reveal>
    {mobile ? <CopyrightMobile /> : <CopyrightDesktop />}
  </Wrapper>
)

export default Bottom



// WEBPACK FOOTER //
// /opt/build/repo/src/components/pages/home/HomeBottom.js